// import { useParams } from 'next/navigation';
import { SVGProps } from 'react';

const CatalogVector = (props: SVGProps<SVGSVGElement>) => {
  // const { section } = useParams<{ section?: string }>();
  // const sectionValue = section?.toLowerCase();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="800"
      height="800"
      viewBox="0 0 24 24"
      fill="none"
      // stroke={sectionValue === 'woman' || !sectionValue ? '#fff' : '#000'}
      {...props}
    >
      {' '}
      <path d="M10.4727 10.9997V18.3681L15.7358 20.9996M10.4727 10.9997L15.7358 8.36816L20.9989 10.9997M10.4727 10.9997L15.7358 14.1576M15.7358 20.9996L20.9989 18.3681V10.9997M15.7358 20.9996V14.1576M20.9989 10.9997L15.7358 14.1576" />
      <path d="M17.3156 6.78942C17.3156 4.15787 17.3156 1 17.3156 1L2.57893 1.00001C2.05262 1.00001 1 1.42105 1 3.10525C1 4.78944 1 14.6841 1 19.4209C1 19.7718 1.42105 20.4735 3.10524 20.4735C4.78944 20.4735 8.71922 20.4735 10.4736 20.4735" />
    </svg>
  );
};

export default CatalogVector;
